import React from 'react'
import { ShopContext } from './shopContext'

export const useShopType = () => React.useContext(ShopContext)